import React from 'react';
import moment from 'moment';
import RequestDetailModal from '../../../travel-expense/detail/index';
import InfoTooltip from '../../../common/tooltip/info/index';
import getCurrencySymbol from '../../../../constants/currencies';
import { withNamespaces } from 'react-i18next';

class GeneralTableRow extends React.Component {
  constructor(props) {
    super(props);

    this.getStatusView = this.getStatusView.bind(this);
    this.getActionsView = this.getActionsView.bind(this);

    this.state = {
      request: this.props.request
    };
  }

  componentDidMount() {
    const { request, employee } = this.props;
    const payload = { ...request };

    payload.employee = employee;
    this.setState({ request: payload });
  }

  getStatusView() {
    const { request, t } = this.props;

    if (request.status === 'completed' && request.uploaded === 1) {
      return (
        <InfoTooltip info={t('approvedInfo')}>
          <span className="fa fa-2x fa-check text-success" />
        </InfoTooltip>
      );
    }

    return (
      <InfoTooltip info={t('waitingToBeTransfer')}>
        <span className="fa fa-2x fa-clock-o text-info" />
      </InfoTooltip>
    );
  }

  getActionsView() {
    return [
      <div key={1}>
        <RequestDetailModal
          request={this.state.request}
          isManager
          approve={() => {}}
          reject={() => {}}
        />
        <span>
&nbsp;
        </span>
      </div>,
    ];
  }

  render() {
    const { request, t } = this.props;
    const { calculatedAmount } = request;

    return (
      <div className="request-row">
        <div className="row">
          <div className="col-md-1">
            <span>
              {this.getStatusView()}
            </span>
          </div>
          <div className="col-md-2">
            <span>
              {moment(new Date(request.travelStartDate)).format('DD-MM-YYYY')}
              {' '}
              {request.travelStartHour}
            </span>
            <br />
            <span>
              {moment(new Date(request.travelEndDate)).format('DD-MM-YYYY')}
              {' '}
              {request.travelEndHour}
            </span>
          </div>
          <div className="col-md-2 ellipsis">
            <span>
              {request.travelReasons.map(reason => (
                <span
                  key={reason.value}
                >
                  {reason.label}
                </span>
              ))}
            </span>
          </div>
          <div className="col-md-2 ellipsis">
            {
                            request.type === 'domestic'
                              ? (request.domestic.provinces.map(p => (
                                <span key={p.value}>
                                  {' '}
                                  {p.label}
                                  {' '}
                                </span>
                              )))
                              : (
                                <span>
                                  {request.abroad.country}
                                </span>
                              )
                        }
          </div>
          <div className="col-md-1">
            <InfoTooltip info={t('travelExpenseGrossPayment')}>
              {
                                request && request.status === 'completed'
                                  ? (
                                    <span>
                                      {calculatedAmount.amount}
                                      {' '}
                                      {getCurrencySymbol(
                                        calculatedAmount.abroadCurrency)}
                                    </span>
                                  )
                                  : <span />

                            }

            </InfoTooltip>
          </div>
          <div className="col-md-2">
            <InfoTooltip info={t('individualAccommodationAmount')}>
              <span>
                {calculatedAmount.individualAccommodationAmount
                  ? calculatedAmount.individualAccommodationAmount
                  : 0}
                {' '}
                {getCurrencySymbol(
                  calculatedAmount.abroadCurrency)}
              </span>
            </InfoTooltip>
          </div>
          <div className="col-md-2">
            {this.getActionsView()}
          </div>
        </div>
      </div>
    );
  }
}

export default withNamespaces()(GeneralTableRow);



// WEBPACK FOOTER //
// ./src/components/hr/components/sub-row/index.js